import(/* webpackMode: "eager" */ "/codebuild/output/src614861593/src/apps/fanychance/src/app/error.tsx");
